
import { defineComponent } from 'vue'
import { View, Close, UploadFilled, Download, DocumentCopy, CircleCheckFilled, Plus, Hide, FolderAdd, Upload } from '@element-plus/icons-vue'
import { ElImageViewer } from 'element-plus'
import tableComponent from '@/components/table-component/index.vue'
import DrawerEmployeeDetail from '@/views/components/employee/drawer-employee-detail.vue'
import { downloadFileAndChangeName } from '@/utils/util'
import {
    importAddressBook,
    getLabel,
    addLabel,
    deleteLabel,
    addUserLabel,
    queryUserDetailInfo,
    queryEmployeeList,
    exportEmployeeList,
    Employee,
    removeUserLabel,
    removeUserLabelDto,
    ImportAddressBookResult,
    apiUploadFile
} from '@/api/resume'
import { Label } from '@/api/resume'
import user from '@/utils/user'

interface TagWithChecked extends Label {
    checked: boolean
    deleting?: boolean
}

const accountStatusOptions = [
    { label: '正常', value: '0' },
    { label: '已注销', value: '1' }
]
const insureStatusOptions = [
    { label: '保障中', value: 'insured' },
    { label: '待生效', value: 'pending' }
]

export default defineComponent({
    name: 'EmploymentManagement',
    components: {
        View,
        Close,
        UploadFilled,
        Download,
        DocumentCopy,
        CircleCheckFilled,
        Plus,
        FolderAdd,
        Upload,
        tableComponent,
        DrawerEmployeeDetail,
        ElImageViewer
    },
    data() {
        return {
            uploadVisible: false,
            fileList: [] as any,
            uploadedFile: null as any,
            dragover: false,
            searchList: {
                searchText: {
                    name: '员工姓名',
                    prop: 'searchText',
                    type: 'input',
                    placeholder: '请输入员工姓名',
                    value: '',
                    defaultValue: ''
                },
                phone: {
                    name: '手机号',
                    prop: 'phone',
                    type: 'input',
                    placeholder: '请输入手机号',
                    value: '',
                    defaultValue: ''
                },
                idCardNo: {
                    name: '身份证号',
                    prop: 'idCardNo',
                    type: 'input',
                    placeholder: '请输入身份证号',
                    value: '',
                    defaultValue: ''
                },
                isLogout: {
                    name: '账号状态',
                    prop: 'isLogout',
                    type: 'select',
                    placeholder: '请选择账号状态',
                    value: '',
                    defaultValue: '',
                    options: accountStatusOptions,
                    defaultAttrs: {
                        label: 'label',
                        value: 'value'
                    }
                },
                statusFilter: {
                    name: '投保状态',
                    prop: 'statusFilter',
                    type: 'select',
                    placeholder: '请选择投保状态',
                    value: '',
                    defaultValue: '',
                    options: insureStatusOptions,
                    defaultAttrs: {
                        label: 'label',
                        value: 'value'
                    }
                },
                labelIds: {
                    name: '员工标签',
                    prop: 'labelIds',
                    type: 'select',
                    placeholder: '请选择员工标签',
                    value: [],
                    defaultValue: [],
                    options: [],
                    defaultAttrs: {
                        label: 'label',
                        value: 'value'
                    }
                },
                entryTime: {
                    name: '入职时间',
                    prop: 'EntryTime',
                    type: 'dateRange',
                    startPlaceholder: '开始时间',
                    endPlaceholder: '结束时间',
                    value: []
                }
            } as any,
            tableHead: [
                { prop: 'index', fixed: 'left' },
                { prop: 'workerName', label: '员工姓名', fixed: 'left' },
                { prop: 'sex', label: '性别', width: 80 },
                { prop: 'age', label: '年龄', width: 80 },
                { prop: 'phone', label: '手机号', width: 150 },
                { prop: 'idCardNo', label: '身份证号', width: 200 },
                { prop: 'isLogout', label: '账号状态', width: 100 },
                { prop: 'isResign', label: '在职状态', width: 100 },
                { prop: 'statusFilter', label: '投保状态', width: 100 },
                { prop: 'isActivity', label: '激活状态', width: 100, headerSlot: true }, //近30天未发薪、投保、签合同的职工被判断为未激活，入职30天以内的不在此判断内
                { prop: 'labels', label: '员工标签', width: 200 },
                { prop: 'projectRemark', label: '项目备注', width: 100 },
                { prop: 'createTime', label: '入职时间', width: 150 },
                { prop: 'operate', label: '操作', width: 150, fixed: 'right' }
            ] as any,
            tableData: [] as any,
            pageInfo: {
                pageNum: 1,
                pageSize: 10,
                hasNextPage: false,
                totalCount: 0
            } as any,
            // 统计数据
            statistics: {
                totalCount: 0,
                menCount: 0,
                womenCount: 0
            },
            selects: [] as any,
            // 弹窗相关
            currentRow: {} as any,
            // 图片预览
            imageViewerVisible: false,
            previewImages: [] as string[],
            // 标签弹窗相关
            tagDialogVisible: false,
            addTagDialogVisible: false,
            deleteTagDialogVisible: false,
            pendingDeleteTag: null as any,
            removeErrorDialogVisible: false,
            removeErrorGroups: [] as { reason: string, names: string[] }[],
            tagTargetRows: [] as any, // 当前操作的员工列表
            hoveredTagId: null as any, // 鼠标悬停的标签ID
            systemTags: [] as TagWithChecked[],
            customTags: [] as TagWithChecked[],
            removeModeTagIds: new Set<string>(), // 移除模式下要显示的标签ID
            newTagForm: {
                name: ''
            },
            isRemoveMode: false, // 是否为移除标签模式
            // 标记离职提示弹窗相关
            resignWarningVisible: false,
            noRemindResignWarning: false,
            pendingResignTag: null as any, // 待确认的离职标签
            // 员工详情抽屉
            detailDrawerVisible: false,
            detailEmployeeData: {} as any,
            // 标记大神弹窗相关
            markExpertDialogVisible: false,
            markExpertTargetRow: {} as any,
            markExpertForm: {
                remark: '',
                images: [] as string[]
            },
            blackListRemark: '',
            blackListRemarkImg: '',
            hasSearchedStatusFilter: false, // 标记是否主动搜索过投保状态
            importErrorDialogVisible: false,
            importErrorList: [] as ImportAddressBookResult[],
            currentIsPcAdmin: false as boolean | number,
            currentIsSupPcAdmin: false as boolean | number,
            visibilityMap: new Map<string, { idCardNo: boolean; phone: boolean }>()
        }
    },
    async mounted() {
        if (!user.userId) {
            try { await user.getUserInfo() } catch { /* 忽略，按非管理员处理 */ }
        }
        this.currentIsPcAdmin = user.isPcAdmin
        this.currentIsSupPcAdmin = user.isSupPcAdmin
        this.getData()
        this.loadLabels()
    },
    computed: {
        selectedSystemTags() {
            return (this.systemTags || []).filter((tag: any) => tag.checked)
        },
        selectedCustomTags() {
            return (this.customTags || []).filter((tag: any) => tag.checked)
        },
        filteredTableHead() {
            return this.tableHead.filter((col: any) => {
                if (col.prop === 'statusFilter') {
                    return this.hasSearchedStatusFilter
                }
                return true
            })
        },
        filteredTableData() {
            if (!this.searchList.statusFilter.value) {
                return this.tableData
            }
            return this.tableData.filter((row: any) => row.statusFilter === this.searchList.statusFilter.value)
        },
        isAdminOrAbove(): boolean {
            return !!this.currentIsPcAdmin || !!this.currentIsSupPcAdmin
        },
        // 批量移除弹窗里展示的标签：合并系统+自定义，过滤"标记离职"和未被选中员工命中的
        removeModeTags(): any[] {
            const all = [...(this.systemTags || []), ...(this.customTags || [])]
            return all.filter((tag: any) =>
                tag.labelName !== '标记离职' && this.removeModeTagIds.has(String(tag.id))
            )
        }
    },
    watch: {
        'searchList.statusFilter.value'() {
            this.hasSearchedStatusFilter = false
        }
    },
    methods: {
        getData() {
            const query = this.createQuery()
            queryEmployeeList(query).then((res: any) => {
                this.tableData = res.list || []
                this.pageInfo.hasNextPage = res.hasNextPage
                this.pageInfo.totalCount = res.totalCount
                this.statistics.totalCount = res.totalCount
                this.statistics.menCount = res.maleCount
                this.statistics.womenCount = res.femaleCount
            }).catch((error: any) => {
                console.error('获取表格数据失败', error)
            })
        },
        loadLabels() {
            getLabel().then((res: any) => {
                this.systemTags = (res.systemLabel || []).map((label: any) => ({
                    ...label,
                    checked: false
                }))
                this.customTags = (res.customLabel || []).map((label: any) => ({
                    ...label,
                    checked: false,
                    deleting: false
                }))
                // 更新搜索条件中的员工标签选项
                const allLabels = [...(res.systemLabel || []), ...(res.customLabel || [])]
                this.searchList.labelIds.options = allLabels.map((label: any) => ({
                    label: label.labelName,
                    value: label.id
                }))
            }).catch((error: any) => {
                console.error('加载标签失败', error)
            })
        },
        createQuery(hasPage = true) {
            const query = {} as any
            if (hasPage) {
                query.pageNum = String(this.pageInfo.pageNum)
                query.pageSize = String(this.pageInfo.pageSize)
            }
            for (const key in this.searchList) {
                const searchItem = this.searchList[key]
                if (searchItem.type === 'dateRange') {
                    if (searchItem.value?.length) {
                        query.startDate = searchItem.value[0]
                        query.endDate = searchItem.value[1]
                    }
                } else if (searchItem.value) {
                    switch (key) {
                        case 'searchText':
                            query.searchText = searchItem.value
                            break
                        case 'sex':
                            query.sex = searchItem.value
                            break
                        case 'isLogout':
                            query.isLogout = searchItem.value
                            break
                        case 'statusFilter':
                            query.statusFilter = searchItem.value
                            break
                        case 'labelIds':
                            if (Array.isArray(searchItem.value) && searchItem.value.length > 0) {
                                const validIds = searchItem.value.filter((id: any) => id !== '' && id != null)
                                if (validIds.length > 0) {
                                    query.labelIds = validIds.map((id: any) => Number(id)).join(',')
                                }
                            }
                            break
                        default:
                            query[searchItem.prop] = searchItem.value
                    }
                }
            }
            return query
        },
        handleSearch() {
            this.pageInfo.pageNum = 1
            this.tableData = []
            this.hasSearchedStatusFilter = !!this.searchList.statusFilter.value
            this.getData()
        },
        handleReset() {
            for (const key in this.searchList) {
                const searchItem = this.searchList[key]
                if (searchItem.type === 'dateRange') {
                    searchItem.value = []
                } else {
                    searchItem.value = searchItem.defaultValue || ''
                }
            }
            this.hasSearchedStatusFilter = false // 重置标记
            this.pageInfo.pageNum = 1
            this.tableData = []
            this.getData()
        },
        handleLabelChange(value: any[]) {
            if (value.length > 10) {
                this.$message.warning('最多只能选择10个标签')
                this.searchList.labelIds.value = value.slice(0, 10)
            }
        },
        handleSizeChange(ev: number) {
            this.pageInfo.pageSize = ev
            this.pageInfo.pageNum = 1
            this.tableData = []
            this.getData()
        },
        handleCurrentChange(ev: number) {
            this.pageInfo.pageNum = ev
            this.getData()
        },
        handleSelectionChange(selections: any[]) {
            this.selects = selections.map((item: any) => item.id)
        },
        formatIdCard(idCardNo: string) {
            if (!idCardNo) return '--'
            return idCardNo.replace(/(\d{3})\d+(\d{4})/, '$1****$2')
        },
        formatPhone(phone: string) {
            if (!phone) return '--'
            return phone.replace(/(\d{3})\d+(\d{4})/, '$1****$2')
        },
        getDisplayValue(rowId: string | number, field: 'idCardNo' | 'phone', value: string) {
            if (!value) return '--'
            const visibility = this.visibilityMap.get(String(rowId))
            const isVisible = field === 'idCardNo' ? visibility?.idCardNo : visibility?.phone
            if (isVisible) return value
            return field === 'idCardNo' ? this.formatIdCard(value) : this.formatPhone(value)
        },
        isIdCardVisible(rowId: string | number) {
            return this.visibilityMap.get(String(rowId))?.idCardNo ?? false
        },
        isPhoneVisible(rowId: string | number) {
            return this.visibilityMap.get(String(rowId))?.phone ?? false
        },
        toggleVisibility(rowId: string | number, field: 'idCardNo' | 'phone') {
            const key = String(rowId)
            const current = this.visibilityMap.get(key) || { idCardNo: false, phone: false }
            if (field === 'idCardNo') {
                current.idCardNo = !current.idCardNo
            } else {
                current.phone = !current.phone
            }
            this.visibilityMap.set(key, current)
        },
        truncateText(text: string, maxLength: number) {
            if (!text) return ''
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
        },
        handlePreviewImages(images: string[]) {
            this.previewImages = images.filter(img => img)
            if (this.previewImages.length > 0) {
                this.imageViewerVisible = true
            }
        },
        handleExport() {
            const exportQuery: any = this.createQuery(false)
            exportQuery.isResign = "0"
            if (this.selects && this.selects.length > 0) {
                const selectedRows = this.tableData.filter((row: any) => this.selects.includes(row.id))
                const idCardNos = selectedRows
                    .map((row: any) => row.idCardNo)
                    .filter(Boolean)
                if (idCardNos.length > 0) {
                    exportQuery.idCardNos = idCardNos.join(',')
                }
            }
            exportEmployeeList(exportQuery).then((res: any) => {
                this.$store.commit('getLongPollingFile', res)
                this.$message.success('导出成功')
            }).catch(() => {
            })
        },
        handleFileSelect(event: any) {
            // 处理文件选择
            const files = event.target.files
            if (files && files.length > 0) {
                this.processFile(files[0])
            }
        },
        handleDrop(event: any) {
            this.dragover = false
            const files = event.dataTransfer.files
            if (files && files.length > 0) {
                this.processFile(files[0])
            }
        },
        processFile(file: any) {
            const fileName = file.name.toLowerCase()
            if (!fileName.endsWith('.xls') && !fileName.endsWith('.xlsx')) {
                this.$message.error('只支持 .xls 和 .xlsx 格式的文件')
                return
            }

            // 验证文件大小（10MB）
            const maxSize = 10 * 1024 * 1024
            if (file.size > maxSize) {
                this.$message.error('文件大小不能超过 10MB')
                return
            }

            this.uploadedFile = file
            console.log('文件已选择:', {
                name: file.name,
                size: file.size,
                type: file.type,
                lastModified: file.lastModified
            })
        },
        handleBatchImport() {
            this.fileList = []
            this.uploadedFile = null
            this.uploadVisible = true
            console.log('导入名单')
        },
        handleDetail(row: Employee) {
            // 查询员工详细信息
            queryUserDetailInfo({ userId: row.userId }).then((res: any) => {
                this.detailEmployeeData = {
                    id: row.id,
                    userId: row.userId,
                    name: res.userName,
                    userHeadUrl: res.userHeadUrl || '../assets/avatar.png',
                    idCardNo: res.idCardNo,
                    phone: res.phone,
                    gender: res.sex === '0' ? 'male' : 'female',
                    age: res.age || 0,
                    address: res.area,
                    jobIntention: res.jobIntention,
                    idCardBack: res.idCardBack,
                    idCardFront: res.idCardFront,
                    healthCard: res.healthCard,
                    bankCardImg: res.bankCardImg,
                    bankCardNo: res.bankCardNo,
                    educationExperience: res.educationExperiences,
                    labelList: res.labelList,
                }
                this.detailDrawerVisible = true
            }).catch((error: any) => {
                console.error('获取员工详情失败', error)
                this.$message.error('获取员工详情失败')
            })
        },
        handleDelete(row: any) {
            console.log('删除', row)
        },
        // 标签相关方法
        resetTags() {
            if (!this.systemTags || !this.customTags) return
            this.systemTags.forEach((tag: any) => {
                tag.checked = false
            })
            this.customTags.forEach((tag: any) => {
                tag.checked = false
            })
        },
        handleAddTag(row: any) {
            this.tagTargetRows = [row]
            this.resetTags()
            // 设置当前项已有的标签为选中状态
            if (row.labels && row.labels.length > 0) {
                const currentLabelIds = row.labels.map((label: any) => label.labelId)
                this.systemTags.forEach((tag: any) => {
                    if (currentLabelIds.includes(tag.id)) {
                        tag.checked = true
                    }
                })
                this.customTags.forEach((tag: any) => {
                    if (currentLabelIds.includes(tag.id)) {
                        tag.checked = true
                    }
                })
            }
            this.tagDialogVisible = true
        },
        handleBatchRemoveTag() {
            if (this.selects.length === 0) {
                this.$message.warning('请先选择员工')
                return
            }
            this.tagTargetRows = this.tableData.filter((row: any) => this.selects.includes(row.id))
            this.isRemoveMode = true
            this.resetTags()

            // 收集所有选中员工的标签
            this.removeModeTagIds = new Set<string>()
            this.tagTargetRows.forEach((row: any) => {
                if (row.labels && row.labels.length > 0) {
                    row.labels.forEach((label: any) => {
                        this.removeModeTagIds.add(String(label.labelId))
                    })
                }
            })
            this.tagDialogVisible = true
        },
        handleBatchTag() {
            if (this.selects.length === 0) {
                this.$message.warning('请先选择员工')
                return
            }
            this.tagTargetRows = this.tableData.filter((row: any) => this.selects.includes(row.id))
            this.resetTags()
            this.tagDialogVisible = true
        },
        handleAddCustomTag() {
            this.newTagForm.name = ''
            this.addTagDialogVisible = true
        },
        handleConfirmAddTag() {
            if (!this.newTagForm.name.trim()) {
                this.$message.warning('请输入标签名称')
                return
            }
            addLabel({ labelName: this.newTagForm.name }).then((res: any) => {
                this.$message.success('添加成功')
                getLabel().then((res: any) => {
                    const newAddedTag = res.customLabel.find(
                        (tag) => tag.labelName === this.newTagForm.name
                    )
                    const newTag: TagWithChecked = {
                        id: newAddedTag.id,
                        companyId: 0,
                        labelName: this.newTagForm.name,
                        labelType: 0,
                        createTime: new Date().toISOString(),
                        updateTime: new Date().toISOString(),
                        delFlag: 0,
                        updateUserId: null,
                        createUserId: '',
                        jobPreferences: '',
                        labelCategory: 0,
                        labelDescription: '',
                        params: {},
                        checked: true,
                        deleting: false
                    }
                    this.customTags.push(newTag)
                    // 同步更新筛选下拉里的标签选项
                    this.searchList.labelIds.options.push({
                        label: newTag.labelName,
                        value: newTag.id
                    })
                })
                this.addTagDialogVisible = false
                this.$message.success('添加成功')
            }).catch((error: any) => {
                console.error('添加标签失败', error)
            })
        },
        handleConfirmBatchTags() {
            if (this.isRemoveMode) {
                this.handleConfirmRemoveTags()
            } else {
                this.handleSaveTags()
            }
        },
        handleSaveTags() {
            console.log(8888888);
            const labelIds = [
                ...this.selectedSystemTags.map((tag: any) => tag.id),
                ...this.selectedCustomTags.map((tag: any) => tag.id)
            ]
            const addressBookIds = this.tagTargetRows.map((row: any) => row.id)

            if (labelIds.length === 0) {
                this.$message.warning('请选择至少一个标签')
                return
            }

            if (labelIds.length > 10) {
                this.$message.warning('最多添加10个标签')
                return
            }

            const params: any = { addressBookIds, labelIds }

            if (this.blackListRemark || this.blackListRemarkImg) {
                params.blackListRemark = this.blackListRemark
                params.blackListRemarkImg = this.blackListRemarkImg
            }

            addUserLabel(params).then(() => {
                this.tagDialogVisible = false
                this.$message.success('标签保存成功')
                this.selects = []
                this.$refs.table.$refs.elTable?.clearSelection?.()
                this.blackListRemark = ''
                this.blackListRemarkImg = ''
                this.getData()
            }).catch((error: any) => {
                console.error('保存标签失败', error)
            })
        },
        handleCancelTags() {
            this.tagDialogVisible = false
            this.isRemoveMode = false
        },
        handleConfirmRemoveTags() {
            const labelIds = [
                ...this.selectedSystemTags.map((tag: any) => tag.id),
                ...this.selectedCustomTags.map((tag: any) => tag.id)
            ]
            console.log(labelIds, "8888888");

            const addressBookIds = this.tagTargetRows.map((row: any) => row.id)

            if (labelIds.length === 0) {
                this.$message.warning('请选择至少一个标签')
                return
            }

            // 移除"标记大神"权限校验：仅原操作人或管理员及以上可解除
            const expertTag = [...this.selectedSystemTags, ...this.selectedCustomTags]
                .find((t: any) => t.labelName === '标记大神')
            if (expertTag) {
                if (!this.isAdminOrAbove) {
                    const currentUserId = String(user.userId)
                    const notOperator = this.tagTargetRows.some((row: any) => {
                        const lbl = (row.labels || []).find((l: any) => l.labelName === '标记大神')
                        if (!lbl) return false
                        return String(lbl.createUserId ?? '') !== currentUserId
                    })
                    if (notOperator) {
                        this.$message.warning('仅操作人或管理员及以上权限可解除"标记大神"')
                        return
                    }
                }
            }

            removeUserLabel({ addressBookIds, labelIds }).then((res: removeUserLabelDto) => {
                this.tagDialogVisible = false
                this.isRemoveMode = false
                this.selects = []
                this.$refs.table.$refs.elTable?.clearSelection?.()
                this.getData()
                const errorList = res?.errorList || []
                if (errorList.length > 0) {
                    // 按 reason 归类，每类下汇总员工姓名
                    const groupMap = new Map<string, string[]>()
                    errorList.forEach((item: any) => {
                        const arr = groupMap.get(item.reason) || []
                        arr.push(item.workerName)
                        groupMap.set(item.reason, arr)
                    })
                    this.removeErrorGroups = Array.from(groupMap.entries()).map(([reason, names]) => ({
                        reason,
                        names
                    }))
                    this.removeErrorDialogVisible = true
                } else {
                    this.$message.success('标签移除成功')
                }
            }).catch((error: any) => {
                console.error('移除标签失败', error)
                this.$message.error('移除标签失败')
            })
        },
        handleAskDeleteTag(tag: any) {
            this.pendingDeleteTag = tag
            this.deleteTagDialogVisible = true
        },
        handleConfirmDeleteTag() {
            const tag = this.pendingDeleteTag
            this.deleteTagDialogVisible = false
            if (!tag) return
            this.handleDeleteTag(tag)
            this.pendingDeleteTag = null
        },
        handleDeleteTag(tag: any) {
            tag.deleting = true
            deleteLabel({ id: tag.id }).then(() => {
                this.customTags = this.customTags.filter((t: any) => t.id !== tag.id)
                this.$message.success('标签已删除')
            }).catch((error: any) => {
                tag.deleting = false
                console.error('删除标签失败', error)
                this.$message.error('删除标签失败')
            })
        },
        // 处理系统标签变化
        handleSystemTagChange(tag: any) {
            if (this.isRemoveMode) {
                return
            }
            if (tag.checked && (tag.labelName === '标记离职' || tag.labelName === '标记大神')) {
                if (!this.isAdminOrAbove) {
                    this.$message.warning('仅管理员可执行该操作')
                    tag.checked = false
                    return
                }
                // 已标记则跳过弹窗
                const alreadyMarked = this.tagTargetRows.every((row: any) =>
                    (row.labels || []).some((l: any) => l.labelName === tag.labelName)
                )
                if (alreadyMarked) {
                    return
                }
            }
            if (tag.checked && tag.labelName === '标记离职') {
                const noRemind = localStorage.getItem('noRemindResignWarning')
                if (noRemind === 'true') {
                    return
                }
                this.pendingResignTag = tag
                tag.checked = false
                this.resignWarningVisible = true
            }
            if (tag.checked && tag.labelName === '标记大神') {
                this.markExpertForm.remark = ''
                this.markExpertForm.images = []
                this.markExpertDialogVisible = true
            }
        },
        handleExceedImage() {
            this.$message.warning('最多只能上传4张图片')
        },
        handleImageChange(file: any, fileList: any[]) {
            if (fileList.length > 4) {
                fileList.pop()
                this.$message.warning('最多只能上传4张图片')
                return
            }
            this.markExpertForm.images = fileList
            if (file?.raw && !file.serverUrl) {
                apiUploadFile({ file: file.raw as any, filePath: 'file/img/' })
                    .then((res: any) => {
                        file.serverUrl = res?.msg
                        console.log(res, '88888');

                    })
                    .catch((err: any) => {
                        const msg = err?.msg || ''
                        if (typeof msg === 'string' && /^https?:\/\//.test(msg)) {
                            file.serverUrl = msg
                        } else {
                            this.$message.error('图片上传失败')
                            const idx = this.markExpertForm.images.indexOf(file)
                            if (idx > -1) this.markExpertForm.images.splice(idx, 1)
                        }
                    })
            }
        },
        getImageUrl(file: any) {
            if (file.url) {
                return file.url
            }
            if (file.thumbUrl) {
                return file.thumbUrl
            }
            if (file.raw) {
                return window.URL.createObjectURL(file.raw)
            }
            return ''
        },
        removeImage(index: number) {
            const file = this.markExpertForm.images[index]
            // 释放临时 URL，防止内存泄漏
            if (file?.raw && !file.url && !file.thumbUrl) {
                URL.revokeObjectURL(this.getImageUrl(file))
            }
            this.markExpertForm.images.splice(index, 1)
        },
        handleConfirmMarkExpert() {
            // 检查是否有图片还在上传中
            const pending = this.markExpertForm.images.some((f: any) => f.raw && !f.serverUrl)
            if (pending) {
                this.$message.warning('图片上传中，请稍候')
                return
            }
            this.blackListRemark = this.markExpertForm.remark
            this.blackListRemarkImg = this.markExpertForm.images
                .map((file: any) => file.serverUrl || '')
                .filter(Boolean)
                .join(',')
            this.markExpertDialogVisible = false
        },
        // 取消标记离职提示
        handleCancelResignWarning() {
            this.resignWarningVisible = false
            this.pendingResignTag = null
            this.noRemindResignWarning = false
        },
        // 确认标记离职提示
        handleConfirmResignWarning() {
            if (this.noRemindResignWarning) {
                localStorage.setItem('noRemindResignWarning', 'true')
            }
            // 选中待确认的标签
            if (this.pendingResignTag) {
                this.pendingResignTag.checked = true
                this.pendingResignTag = null
            }
            this.resignWarningVisible = false
            this.noRemindResignWarning = false
        },
        handleReupload() {
            this.uploadedFile = null
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = ''
            }
        },
        handleCancelUpload() {
            this.uploadVisible = false
            this.uploadedFile = null
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = ''
            }
        },
        handleConfirmUpload() {
            if (!this.uploadedFile) {
                this.$message.warning('请先选择文件')
                return
            }
            importAddressBook({ file: this.uploadedFile }).then((res: ImportAddressBookResult[]) => {
                this.uploadVisible = false
                this.uploadedFile = null
                if (res.length > 0) {
                    this.importErrorList = res
                    this.importErrorDialogVisible = true
                } else {
                    this.$message.success('导入成功')
                }
                this.getData()
            }).catch((error: any) => {
                console.error('导入失败', error)
            })
        },
        handleDownloadTemplate() {
            const url = 'https://new1-bullet001.oss-cn-shanghai.aliyuncs.com/template/excel/pay/address_book/address_book_temp.xlsx'
            fetch(url)
                .then(response => response.blob())
                .then(blob => {
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = 'address_book_temp.xlsx'
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    URL.revokeObjectURL(link.href)
                })
                .catch(() => {
                    this.$message.error('下载失败，请稍后重试')
                })
        }
    }
})
